import { Component, inject, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { UserService } from "src/app/services/user/user.service";
import { OrwiScratchService } from "../../gamification/orwi-scratch/orwi-scratch.service";
import { ScratchService } from "../../gamification/orwi-scratch/state/scratch.service";
import { CouponService } from "src/app/services/store/coupon.service";
import { Coupon } from "src/app/services/dto/orwi-store";

@Component({
  selector: "app-scratch",
  templateUrl: "./scratch.component.html",
  styleUrls: ["./scratch.component.scss"],
})
export class ScratchComponent{
  userService = inject(UserService);
  nav = inject(NavController);
  orwiScratchService = inject(OrwiScratchService);

  goTo() {
    if (this.userService.user.isVirtual) {
      this.nav.navigateForward("otp-request");
    } else {
      this.orwiScratchService.showComponent();
    }
  }
}
